module.exports = __webpack_public_path__ + "img/icon_check.5a6bbd01.svg";